// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__Bwzyq","blink":"DotDotDot_blink__ZBvPc"};